import { SubmitHandler } from 'react-hook-form'
import { type RegisterInput } from '.'
import {
  usePostApiV1AccountsPasswordRecoverCheckCodeMutation,
  usePostApiV1AccountsPasswordRecoverMutation,
} from '../../../../authApi'
import { authSlice } from '../../../../authSlice'
import { useDispatch } from 'react-redux'
import { logger } from 'helpers/logger'
import { fixedCacheKey as useSendPassCodeFixedCacheKey } from '../ForgotPasswordPassCode/hooks/useSendPassCode'
import { useLogout } from '../../../../hooks/useLogout'
import { useState } from 'react'

export const fixedCacheKey = 'usePostApiV1AccountsPasswordRecoverMutation'

export const useSubmit = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { logout } = useLogout()
  const dispatch = useDispatch()
  const { setForgotPasswordStep, updateForgotPasswordFields } =
    authSlice.actions

  const [, { reset }] = usePostApiV1AccountsPasswordRecoverCheckCodeMutation({
    fixedCacheKey: useSendPassCodeFixedCacheKey,
  })

  const [recoverPassword, state] = usePostApiV1AccountsPasswordRecoverMutation({
    fixedCacheKey,
  })

  const onSubmit: SubmitHandler<RegisterInput> = async ({ login }) => {
    try {
      setIsLoading(true)
      reset()
      state.reset()
      logout()

      await recoverPassword({ passwordRecoveryRequest: { login } }).unwrap()

      dispatch(updateForgotPasswordFields({ login }))
      dispatch(setForgotPasswordStep('passCode'))
    } catch (error) {
      logger.error('Submit forgot password request error: ', error)
    } finally {
      setIsLoading(false)
    }
  }

  return { onSubmit, ...state, isLoading }
}
